import type { NominationDeclaration } from '../../../graphql/NominationForm';

export enum DeclarationType {
  ALL = 'ALL',
  HKPFS = 'HKPFS',
  EXTERNAL = 'EXTERNAL',
  BOTH = 'BOTH',
}

export type DeclarationValues = {
  content: NominationDeclaration;
  confirmed: boolean;
  justification?: string;
};
